import React, { useEffect,useContext } from "react";

import {
  AboutPage,
  AboutScreen,
  AboutMainContainer,
  AboutLottieContainer,
  AboutDataContainer,
  AboutCard,
  ConnectionLink,
  AboutLottie,
} from "./about.styles";
import { ReactComponent as WaveSvg1 } from "../../assets/svgs/wave-haikei-1.svg";
import Lottie from "react-lottie";
import laptopLottie from "../../assets/lotties/laptopLottie.json";

import Starback from "starback";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";
import { Fade } from "react-reveal";
import {ThemeContext} from '../../theme.context';

const About = () => {
  const laptopLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: laptopLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const {darkMode} = useContext(ThemeContext);

  useEffect(() => {
    const canvas2 = document.getElementById("about-canvas");
    const wi = window.innerWidth;
    const hi = window.innerHeight - 50;
    // const starback = new Starback(canvas2, {
    //   width: wi,
    //   height: hi,
    // type: 'line',
    // speed: 5,
    // frequency: 5,
    // slope: { x: -1, y: 10 },
    // directionX: 1,
    // speed: 3,
    // spread: -10,
    // randomOpacity: true,
    // backgroundColor: ['#ff0000'],
    // quantity: 30,
    // });
  }, []);
  return (
    <AboutPage dark={darkMode}>
      {/* <canvas id="about-canvas" style={{position:'absolute',top:'100vh'}}></canvas> */}
      <div class="wave1">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
            fill={darkMode?"#FF3B81":"#3957D2"}
          ></path>
        </svg>
      </div>
      <AboutScreen id="about-section" dark={darkMode}>
        <Fade left>
          <h1 className="page-title">KNOW ABOUT ME !</h1>
        </Fade>
        <AboutMainContainer>
          <AboutLottieContainer>
            <Fade left delay={500}>
              <AboutLottie>
                <Lottie
                  options={laptopLottieOptions}
                  width="100%"
                  height="100%"
                />
              </AboutLottie>
            </Fade>
          </AboutLottieContainer>

          <AboutDataContainer>
            <Fade right delay={1000}>
              <AboutCard dark={darkMode}>
                Hey there, I am Shivam. Currently I am a Third Year student at
                Vishwakarma institute Of Technology pursuing Computer Science.
                <br />
                <br /> I love to code, design and work on projects with teams.I
                am a experienced web developer but I am not restricted to the
                web domain.I love to eat, watch movies, listen music and enjoy
                my coffee while coding .<br />
                <br />
                If you still want to know more about me here are links to
                connect with me!
              </AboutCard>
            </Fade>
            <Fade bottom delay={1200}>
              <div className="links-container">
                <ConnectionLink href="https://www.linkedin.com/in/shivam-gavandi-5407aa1b3/" target="_blank" dark={darkMode}>
                  <Icon icon="akar-icons:linkedin-box-fill" fontSize="1.5em" color={darkMode?"#FF3B81":"#3957D2"} />
                </ConnectionLink>
                <ConnectionLink href="https://github.com/Shivam256" target="_blank" dark={darkMode}>
                  <Icon icon="akar-icons:github-fill" fontSize="1.5em" color={darkMode?"#FF3B81":"#3957D2"} />
                </ConnectionLink>
                <ConnectionLink href="https://discord.com/users/730826504321237043" target="_blank" dark={darkMode}>
                  <Icon icon="radix-icons:discord-logo" fontSize="1.5em" color={darkMode?"#FF3B81":"#3957D2"} />
                </ConnectionLink>
                {/* <ConnectionLink href="https://www.snapchat.com/add/shivam.256?share_id=CiZk1pi6k8g&locale=en-US" target="_blank" dark={darkMode}>
                  <Icon icon="bi:snapchat" fontSize="1.5em" color={darkMode?"#FF3B81":"#3957D2"} />
                </ConnectionLink> */}
              </div>
            </Fade>
          </AboutDataContainer>
        </AboutMainContainer>
      </AboutScreen>
      {/* <div class="custom-shape-divider-bottom-1646408644">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
            fill="#ff0000"
          ></path>
        </svg>
      </div> */}
    </AboutPage>
  );
};

export default About;
